import { ErrorMessage, Spinner } from "../../../../../widgets";
import { FC, useCallback } from "react";
import { FetchStatus, Property } from "../../../../../base/types";

import { IControlAttributes } from "../../../../../base/models";
import { InputLabel } from "../../InputLabel";
import clsx from "clsx";
import { useDateTimeProperties } from "./DateTimeProperties";

export const DraftDateTimeComponent: FC<IControlAttributes> = ({
    control, className, props
}) => {
    const { status, properties, bindings, error } = useDateTimeProperties(props);

    const getValue = useCallback(() => {
        if (!bindings) return;

        const binding = bindings.getBinding(Property.InitValue);
        if (!binding || !binding.boundValue) return;

        switch (binding.type) {
            case "Const":
                return `"${binding.boundValue}"`
            case "Expression":
                return `${binding.boundValue?.query}`
            case "Field":
                return `{${binding.boundValue}}`
        }
    }, [bindings])

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    const value = getValue();

    const render = () => {
        const { label, required, title } = properties || {}
        const containerClass = label ? className : ''
        const inputClass = label ? '' : className

        return (
            <InputLabel
                htmlFor={control.controlId}
                title={title}
                label={label}
                required={required}
                className={containerClass}>
                <div className={clsx(inputClass, "form-control form-control-sm")}>
                    {value}
                </div>
            </InputLabel>
        )
    }

    return render();
}

